import { ListItemText, MenuItem } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import React, { FC } from "react";
import ViewEditSelect, { ViewEditSelectProps } from "../view-edit-select";
import { useJogsForUsers } from "../../../hooks/jogs";

type ViewEditSelectJogProps =
  Omit<ViewEditSelectProps, "id" | "label" | "value" | "children"> & {
    id?: string;
    label?: string;
    maxSelectedCount?: number;
    userPrimaryJogId?: string;
    value: string[]; // this enforces a string[] instead of string or string[] from ViewEditSelectProps
    // todo: jcavner: Perhaps add a field to decide which set of jogs to use. I.e., jogsForUsers, jogsForFiltering, or jogsForIncidents. Or a field to simply pass that set of options in?  
}

const ViewEditSelectJog: FC<ViewEditSelectJogProps> = (props) => {
  // const jogOptions = props.userPrimaryJogId?.length ? JogsForUsers : JogsForIncidents;
  const jogOptions = useJogsForUsers(); // todo: jcavner: Still switch based on Users or Incidents?

  return (
    <ViewEditSelect
      disableShrinkLabel={props.disableShrinkLabel}
      id={props.id ?? "jogs"}
      label={props.label ?? "JOGs"}
      isEdit={props.isEdit}
      size={props.size ?? "small"}
      value={props.value}
      menuProps={{
        PaperProps: {
          style: { overflow: "auto", width: "auto" },
        },
      }}
      multiple={props.multiple}
      tooltip={props.tooltip}
      handleInputChange={props.handleInputChange}
      renderValue={(value) => {
        if (Array.isArray(value)) {
          const shortNames = value.map((id) => jogOptions.find(j => j.id === id)?.shortName);
          // filter undefined values (in case event is associated with unfinalized JOG, which the find() returns undefined for)
          // todo: might need to handle this on incident detail form, too.
          return shortNames.filter((n) => n).join(", ");
        }

        return value;
      }}
    >
      {jogOptions.map((jog) => {
        const isMaxCountSelected = !!props.maxSelectedCount && props.value.length >= props.maxSelectedCount;
        const isPrimaryJog = jog.id === props.userPrimaryJogId;
        const isSelected = props.value.includes(jog.id);
        const SelectionIcon = isSelected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;
        const primaryText = jog.name + (isPrimaryJog ? " (user's primary JOG)" : "");
        const secondaryText = jog.name.startsWith(jog.shortName.split(" ")[0]) ? "" : jog.shortName;
        const isDisabled = isPrimaryJog || (isMaxCountSelected && !isSelected) || !props.isEdit;

        // todo: jcavner: If I refactor this component for "single" selection, e.g., "Primary JOG", I will need logic to display items without the checkbox here.
        return (
          <MenuItem key={jog.id} value={jog.id} disabled={isDisabled}>
            <SelectionIcon fontSize="small" style={{ marginRight: 8, padding: 9, boxSizing: "content-box" }} />
            <ListItemText primary={primaryText} secondary={secondaryText} />
          </MenuItem>
        );
      })}
    </ViewEditSelect>
  );
};

export default ViewEditSelectJog;
